export const SENDING_REQUEST = 'COMPANIESLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'COMPANIESLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'COMPANIESLIST_GETALL_FAILURE';